import React from 'react';
import { Switch, Route } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import useGoogleFont from './hooks/useGoogleFont';
import HomePage from './pages/HomePage';
import AppTermsOfUsePage from './pages/AppTermsOfUsePage';
import AppPrivacyPolicyPage from './pages/AppPrivacyPolicyPage';
import AppContactPage from './pages/AppContactPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  useGoogleFont('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');

  return (
    <Switch>
      <Route exact path="/" component={HomePage} />
      <Route exact path="/:appSlug/terms-of-use" component={AppTermsOfUsePage} />
      <Route exact path="/:appSlug/privacy-policy" component={AppPrivacyPolicyPage} />
      <Route exact path="/:appSlug/contact-us" component={AppContactPage} />
      <Route component={NotFoundPage} />
    </Switch>
  );
}

export default App;
